const steps = [
  {
    number: '01',
    icon: 'ri-chat-smile-2-line',
    title: 'Initial Consultation',
    desc: 'A personal conversation — in-store, at your home, or at your office. We learn your style, lifestyle, needs, and goals to guide every decision that follows.',
  },
  {
    number: '02',
    icon: 'ri-ruler-2-line',
    title: 'Precision Measurements',
    desc: '30+ body measurements map your unique proportions. This is the foundation of every garment — no guesswork, no standardized sizes, no compromises.',
  },
  {
    number: '03',
    icon: 'ri-palette-line',
    title: 'Fabric & Style Selection',
    desc: 'Browse 5,000+ premium fabrics from the world\'s finest mills — Italian wools, English tweeds, Egyptian cottons, cashmere blends, and more.',
  },
  {
    number: '04',
    icon: 'ri-scissors-2-line',
    title: 'Masterful Construction',
    desc: 'Our craftsmen cut and construct your garment entirely by hand using traditional bespoke techniques refined over 55+ years of dedicated practice.',
  },
  {
    number: '05',
    icon: 'ri-check-double-line',
    title: 'Fitting & Final Delivery',
    desc: 'You try on your garment. We make fine adjustments. We don\'t hand it over until the fit, drape, and every finish detail is exactly right.',
  },
];

const ServicesProcessSection = () => {
  return (
    <section className="py-32 bg-[#1a1a1a] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-4">
            How It Works
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Tailoring Process
          </h2>
          <p className="text-gray-400 text-xl max-w-2xl mx-auto">
            A refined five-step journey from first conversation to a garment that fits unlike anything you have ever worn.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative rounded-3xl overflow-hidden h-[680px] order-2 lg:order-1">
            <img
              src="https://public.readdy.ai/ai/img_res/aa6d093ec108509998652577ad971708.jpg"
              alt="Custom tailoring consultation and measurement process at Custom Clothiers"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8 right-8 bg-black/70 backdrop-blur-md border border-[#C4A962]/30 rounded-2xl p-6">
              <p className="text-[#C4A962] text-xs font-bold tracking-widest uppercase mb-2">Our Standard</p>
              <p className="text-white font-semibold text-base leading-snug">
                "We don't hand over a garment until the fit, drape, and every detail is perfect."
              </p>
            </div>
          </div>

          {/* Right: Steps */}
          <div className="order-1 lg:order-2">
            <div className="space-y-0">
              {steps.map((step, index) => (
                <div key={step.number} className="flex gap-5 group">
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-14 h-14 rounded-2xl bg-[#C4A962]/15 border border-[#C4A962]/35 flex items-center justify-center group-hover:bg-[#C4A962]/25 transition-colors">
                      <i className={`${step.icon} text-[#C4A962] text-xl`}></i>
                    </div>
                    {index < steps.length - 1 && (
                      <div className="w-px h-10 bg-gradient-to-b from-[#C4A962]/30 to-transparent my-1"></div>
                    )}
                  </div>
                  <div className={`${index < steps.length - 1 ? 'pb-8' : ''} pt-2`}>
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-[#C4A962] text-xs font-bold tracking-widest uppercase">Step {step.number}</span>
                    </div>
                    <h3 className="text-lg font-bold text-white mb-2">{step.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesProcessSection;
